import React, {createRef, useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {useQueryClient} from "react-query";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";
import parse from "html-react-parser";

import "../../App.css";
import SystemContext from "../../SystemContext";
import {getDefaultValuesWithoutAlert} from "../../functions/TemplateHelperFunctions";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import Dialog from "../../controls/Dialog";
import UploadBookingStyles from "./styles/UploadBookingStyles";
import {Loading} from "../../controls";
import {useCompanies} from "../../services/companies";
import __ from "lodash";
import BookingListUploadDialog from "./components/BookingListUploadDialog";

const AccessControl = require ("../../AccessControl");


function UploadCustomerBookingList(props) {
  const SystemData = useContext(SystemContext);
  const classes = makeStyles(UploadBookingStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Manage BOOKINGS", "Client ADMIN", "Client ACCESS"]);
  const userInfo = AccessControl.getUserInfo();
  const userClass = userInfo?.userClass;
  const [defaults, setDefaults] = useState(null);

  const queryClient = useQueryClient();
  const companyData = useCompanies({queryClient, extraKeys: [userInfo?.companyUuid]});

  const history = useHistory();
  const handleClose = event => {
    SystemData.goHome(history);
  };

  const dialogMessage = parse("To process a Booking List from an Excel file, select the Company making the booking and choose a properly formatted Excel File.<br/><br/>The Excel file format will be validated prior to processing; correct any error indicated by the system prior to processing.")
  const title = "Process Booking List Excel File";

  const record = {
    enquirySource: "WEB",
    enquiryDate: moment.utc().toISOString(),
    enquiryInfo: null,
    companyName: null,
    companyUuid: null,
    contactName: null,
    contactEmail: null,
    contactPhone: null,
    originAirportCode: null,
    destinationAirportCode: null,
    payload: null,
    payloadUom: "TONNE",
    cargoAvailability: null,
    requiredAtDestination: null,
    orderFirmness: 0,
    accountManagerId: null,
    status: "NEW",
    nextActionDate: null,
  }

  const getDefaults = async () => {
    const defaults = await getDefaultValuesWithoutAlert(SystemData, "booking", "defaults");
    if (!defaults)
      return null;
    return defaults;
  }

  getDefaults()
    .then((bookingDefaults) => {
      if (!defaults)
        setDefaults(bookingDefaults);

    })
    .catch((error) => {
      handleClose();
      SystemData.alert("Error", error);
    });

  if (userClass ==="GSA" && companyData && companyData.data && Array.isArray(companyData.data) && companyData.data.length > 0) {
    const company = companyData.data[0];
    record["companyUuid"] = userInfo.companyUuid;
    record["companyName"] = company.companyName;

    if (userInfo && __.has(userInfo, ["firstName"]) && __.has(userInfo, ["lastName"])) {
      record["contactSalutation"] = userInfo.title;
      record["contactFirstName"] = userInfo.firstName;
      record["contactLastName"] = userInfo.lastName;
      record["contactEmail"] = userInfo.email;
      record["companyContact"] = `${userInfo.title ? userInfo.title + " " : ""} ${userInfo.firstName ?? ""} ${userInfo.lastName ?? ""} ${userInfo.email?`(${userInfo.email})`:``}`;
    }
  }

  return (isAuthenticated &&
    <div
      className="NewEnquiry"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="newenquiry"
        pageName="New Enquiry"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 40, marginRight: 40, minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, backgroundColor: "#f1f1f1"}}
      >
         {/*formMode:*/}
         {/*=========*/}
         {/*GSA - for GSA bookings (does not require GSA selection),*/}
         {/*OPERATOR - for system operator bookings (requires GSA selection),*/}
         {/*SLR - for special load requests.*/}
         {/*userClass will return "OPERATOR" for Magma users and companyUuid for external users*/}

        <div style={{display: "flex"}}>
          {defaults && companyData
            ?
              <BookingListUploadDialog
                systemData={SystemData}
                defaults={defaults}
                record={record}
                canEdit={canEdit}
                newEnquiry={true}
                formMode={userClass||"WEB"}
                close={handleClose}
                classes={classes}
                dialogStates={{showDialog: true, title, dialogMessage, record}}
                showFullPage={false}
                fullPageStyle={{backgroundColor: "#e1e1e1"}}
              />
            :
              defaults ?
                <Dialog
                  message="Loading Data"
                  open={true}
                  buttons={{}}
                >
                  <Loading/>
                </Dialog>
                : <></>
          }

        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default UploadCustomerBookingList;
